'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reducer;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _reduxActions = require('redux-actions');

var _immutable = require('immutable');

var _fileUploadSetters = require('conversations-internal-schema/file-upload/operators/fileUploadSetters');

var _fileUploadGetters = require('conversations-internal-schema/file-upload/operators/fileUploadGetters');

var _fileUploadsActionTypes = require('../constants/fileUploadsActionTypes');

var _StubbedThreadHistoryActionTypes = require('../../stubbed-thread-history/constants/StubbedThreadHistoryActionTypes');

var _stubbedThreadId = require('../../threads/constants/stubbedThreadId');

var _fileIsUploadingInThread = require('../operators/fileIsUploadingInThread');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = new _immutable.Map();

var reducer = (_reducer = {}, _defineProperty(_reducer, _fileUploadsActionTypes.ATTACHMENT_UPLOAD_START, function (state, action) {
  var _action$payload = action.payload,
      attachment = _action$payload.attachment,
      threadId = _action$payload.threadId;


  return state.withMutations(function (mutableState) {
    if (!(0, _getIn2.default)([threadId], mutableState)) {
      mutableState.set(threadId, new _immutable.OrderedMap());
    }

    mutableState.setIn([threadId, (0, _fileUploadGetters.getLocalId)(attachment)], attachment);
  });
}), _defineProperty(_reducer, _fileUploadsActionTypes.ATTACHMENT_UPLOAD_PROGRESS, function (state, action) {
  var _action$payload2 = action.payload,
      localId = _action$payload2.localId,
      progress = _action$payload2.progress,
      threadId = _action$payload2.threadId;


  if (!(0, _fileIsUploadingInThread.fileIsUploadingInThread)({ localId: localId, threadId: threadId }, state)) {
    return state;
  }

  return state.updateIn([threadId, localId], function (attachment) {
    return (0, _fileUploadSetters.setUploadProgress)(progress, attachment);
  });
}), _defineProperty(_reducer, _fileUploadsActionTypes.ATTACHMENT_UPLOAD_COMPLETE, function (state, action) {
  var _action$payload3 = action.payload,
      fileId = _action$payload3.fileId,
      localId = _action$payload3.localId,
      threadId = _action$payload3.threadId;


  if (!(0, _fileIsUploadingInThread.fileIsUploadingInThread)({ localId: localId, threadId: threadId }, state)) {
    return state;
  }

  return state.updateIn([threadId, localId], function (attachment) {
    return attachment.withMutations(function (mutableAttachment) {
      (0, _fileUploadSetters.setUploadProgress)(100, mutableAttachment);
      (0, _fileUploadSetters.setFileId)(fileId, mutableAttachment);
    });
  });
}), _defineProperty(_reducer, _fileUploadsActionTypes.REMOVE_ATTACHMENT, function (state, action) {
  var _action$payload4 = action.payload,
      localId = _action$payload4.localId,
      threadId = _action$payload4.threadId;


  return state.deleteIn([threadId, localId]);
}), _defineProperty(_reducer, _fileUploadsActionTypes.CLEAR_ATTACHMENTS, function (state, action) {
  var threadId = action.payload.threadId;


  return state.delete(threadId);
}), _defineProperty(_reducer, _StubbedThreadHistoryActionTypes.RESET_STUBBED_THREAD, function (state) {
  return state.delete(_stubbedThreadId.STUBBED_THREAD_ID);
}), _defineProperty(_reducer, _fileUploadsActionTypes.ATTACHMENT_ERROR, function (state, action) {
  var threadId = action.payload.threadId;


  return state.deleteIn([threadId]);
}), _reducer);

exports.default = (0, _reduxActions.handleActions)(reducer, initialState);
module.exports = exports['default'];